import classNames from 'classnames';
import { FunctionComponent } from 'react';

import { useWeblab } from '@amzn/sustainability-central-shared-react';

import { ASX_REBRANDING, LINK_CLASS } from 'src/constants';
import { THEME } from 'src/enums/theme';
import ChevronDownRebrandingIcon from 'src/icons/chevron-down-rebranding.svg';
import ChevronDownIcon from 'src/icons/chevron-down.svg';
import ChevronLeftIcon from 'src/icons/chevron-left.svg';
import ChevronRightIcon from 'src/icons/chevron-right.svg';
import ChevronUpRebrandingIcon from 'src/icons/chevron-up-rebranding.svg';
import ChevronUpIcon from 'src/icons/chevron-up.svg';
import utilStyles from 'src/styles/_utility.scss';

import styles from './Parent.module.scss';

export type ParentStyleVariant = 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'quinary';
interface ParentProps {
  text: string;
  isExpanded: boolean;
  styleVariant?: ParentStyleVariant;
  theme?: THEME;
  onClick: () => void;
}

export const Parent: FunctionComponent<ParentProps> = ({
  isExpanded,
  onClick,
  text,
  styleVariant = 'primary',
  theme = THEME.LIGHT,
}) => {
  const isSecondary = styleVariant === 'secondary';
  const isTertiary = styleVariant === 'tertiary';
  const isQuaternary = styleVariant === 'quaternary';
  const isQuinary = styleVariant === 'quinary';

  const buttonStyles = classNames(styles.parent, styles[theme], LINK_CLASS, {
    [styles.buttonSecondary]: isSecondary,
    [styles.buttonTertiary]: isTertiary,
    [styles.buttonQuaternary]: isQuaternary,
    [styles.buttonQuinary]: isQuinary,
    [styles.isExpanded]: isExpanded,
  });
  const iconStyles = classNames(styles.parentIcon, styles[theme], {
    [styles.iconSecondary]: isSecondary,
    [styles.iconTertiary]: isTertiary,
    [styles.iconQuaternary]: isQuaternary,
    [styles.iconQuinary]: isQuinary,
    [styles.isExpanded]: isExpanded,
  });

  const asxRebrandingWeblab = useWeblab(ASX_REBRANDING);
  const isRebrandingApplied =
    asxRebrandingWeblab === 'T1' || theme === THEME.REBRAND_DARK || theme === THEME.REBRAND_LIGHT;

  const UpIcon = isRebrandingApplied ? ChevronUpRebrandingIcon : ChevronUpIcon;
  const DownIcon = isRebrandingApplied ? ChevronDownRebrandingIcon : ChevronDownIcon;

  return (
    <button className={buttonStyles} onClick={onClick} type="button">
      {isQuaternary && <ChevronLeftIcon className={iconStyles} />}
      <span className={utilStyles.noWrap}>{text}</span>
      {!(isTertiary || isQuaternary) && (
        <span className={utilStyles.noWrap}>
          {!isRebrandingApplied && <>&nbsp;</>}
          {isExpanded ? <UpIcon className={iconStyles} /> : <DownIcon className={iconStyles} />}
        </span>
      )}
      {isTertiary && <ChevronRightIcon className={iconStyles} />}
    </button>
  );
};
